module.exports = __webpack_public_path__ + "static/media/templateRatingRepare.e52b3992.xlsx";